/* buildVersion.js — Visible build marker so operators can confirm
 * which frontend bundle is actually running in the browser.
 *
 * This is the user-visible counterpart to the service-worker
 * VERSION constant (public/service-worker.js).
 *
 * Bump rules
 * ----------
 *   • SEED_EVALUATOR_VERSION — the only field operators look at.
 *     Bump every time `seedErrors.js` / `SettingsPage.onSeed` /
 *     `SparseWorkspaceBanner.onTopUp` change behaviour. The Settings
 *     → Workspace card and the `[seed-trace]` console log both
 *     surface this string so cache vs code is unambiguous.
 *
 *   • BUNDLE_BUILT_AT — a stable token rebuilt by webpack on every
 *     `yarn build`. Useful as a second-line "is this really the
 *     bundle I just deployed?" check.
 *
 * Cache invalidation discipline
 * -----------------------------
 *   CRA emits **content-hashed** static assets — the asset URL
 *   changes on every meaningful code change, so the browser never
 *   re-uses an old asset against a new HTML. The service worker's
 *   navigation strategy is network-first, so the latest HTML
 *   pointer wins as long as the network is up. The risk: an old
 *   service worker activates from cache. The SW VERSION bump in
 *   `public/service-worker.js` (cfos-shell-v5) forces the
 *   `activate` handler to wipe every prior cache.
 */
export const SEED_EVALUATOR_VERSION = "v153";

// Webpack inlines `process.env.REACT_APP_BUILD_AT` at build time.
// Falls back to a session-stable client timestamp during hot-reload
// dev so the marker is never empty.
export const BUNDLE_BUILT_AT =
  (typeof process !== "undefined" && process.env && process.env.REACT_APP_BUILD_AT)
  || (typeof window !== "undefined" ? "dev-" + Math.floor(Date.now() / 1000) : "dev");

// One-time boot log so operators can confirm the bundle on first
// page load without needing to click anything. Strip-once-pilot.
try {
  if (typeof window !== "undefined" && !window.__cf_build_logged) {
    window.__cf_build_logged = true;
    // eslint-disable-next-line no-console
    console.info(
      "[ChainFlow build] seed-evaluator=" + SEED_EVALUATOR_VERSION
      + " bundle=" + BUNDLE_BUILT_AT,
    );
  }
} catch { /* noop */ }
